import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";

export const SellingPlanGroup_Fragment = graphqlShopifyStorefront(`
  fragment SellingPlanGroup on SellingPlanGroup {
    name
    options {
      name
      values
    }
    sellingPlans(first: 4) {
      edges {
        node {
          id
          name
          description
          recurringDeliveries
          options {
            name
            value
          }
        }
      }
    }
  }
`);
